import { QueryClient } from "@tanstack/react-query"
import { createRouter as createTanstackRouter } from "@tanstack/react-router"
import { routerWithQueryClient } from "@tanstack/react-router-with-query"
import {
	CACHE_GC_TIME,
	CACHE_REFETCH,
	CACHE_STALE_TIME,
} from "@/config/constants"
import { NotFound } from "./components/global/elements/404"
import { routeTree } from "./routeTree.gen"

export const createRouter = () => {
	const queryClient = new QueryClient({
		defaultOptions: {
			queries: {
				staleTime: CACHE_STALE_TIME.DEFAULT,
				gcTime: CACHE_GC_TIME.DEFAULT,
				retry: CACHE_REFETCH.RETRY,
				refetchOnWindowFocus: CACHE_REFETCH.ON_WINDOW_FOCUS,
			},
			mutations: {
				retry: false,
			},
		},
	})

	const router = routerWithQueryClient(
		createTanstackRouter({
			routeTree,
			context: {
				queryClient,
			},
			trailingSlash: "preserve",
			scrollRestoration: true,
			defaultPreloadStaleTime: 0,
			defaultNotFoundComponent: NotFound,
		}),
		queryClient,
	)

	return router
}

declare module "@tanstack/react-router" {
	interface Register {
		router: ReturnType<typeof createRouter>
	}
}
